<template>
  <div class="bb-fund-transfer">
    <div class="bb-form">
      <div class="bb-form-item">
        <label class="bb-fund-transfer__label bb-form__label">
          Funds
        </label>
        <custom-select :list="fundsList"
                       styles="short"
                       :table-mode="true"
                       class="bb-fund-transfer__select"
                       @setValue="setFund"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-fund-transfer__label bb-form__label" for="amount">
          Amount
        </label>
        <input class="bb-input bb-input_border"
               :class="{'bb-input_error': invalidAmount}"
               type="text"
               id="amount"
               v-autofocus
               ref="inputAmount"
               autocomplete="off"
               @focus="focusInput()"
               v-model="transfer.amount"
               @keyup.enter="setTransfer"
               @change="errorAmount = false"
               @input="invalidAmount = false">
        <span v-if="errorAmount" class="bb-form-item__error">{{errorAmount}}</span>
      </div>
    </div>
    <div @click="setTransfer" class="bb-fund-transfer__button">
      <slot/>
    </div>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import convertNumber from '@/mixin/convertNumber'
import validateNum from '@/mixin/validateNum'
import _ from 'lodash'

export default {
  name: 'FundTransferWindow',
  props: ['fromFund'],
  mixins: [convertNumber, validateNum],
  components: {
    CustomSelect
  },
  data () {
    return {
      errorAmount: false,
      invalidAmount: false,
      transfer: {
        sourceFund: this.fromFund.id,
        destinationFund: '',
        amount: 0
      }
    }
  },
  computed: {
    fundsList () {
      const funds = _.filter(this.$store.getters.fundsRowsData, item => item.id !== this.fromFund.id)
      return _.sortBy(funds, ['name'])
    }
  },
  methods: {
    focusInput () {
      if (!this.validateNum(this.transfer.amount)) {
        this.transfer.amount = ''
      }
    },
    checkAmountTransfer () {
      const maxAmount = this.fromFund.currentMonthBalance + this.fromFund.lastMonthBalance
      if (maxAmount < this.transfer.amount) {
        this.errorAmount = 'total: ' + this.convertNumber(maxAmount)
      }
      const remain = maxAmount - this.fromFund.paid
      if (remain < 0) {
        this.errorAmount = 'remain: ' + this.convertNumber(remain)
      }
      return maxAmount >= this.transfer.amount && remain > 0
    },
    checkInputs () {
      this.transfer.amount = this.validateNum(this.transfer.amount)
      if (!this.transfer.amount || this.transfer.amount < 0.01 || !this.checkAmountTransfer()) {
        this.invalidAmount = true
        this.$refs.inputAmount.focus()
        return false
      }
      this.invalidAmount = false
      return true
    },
    setFund (item) {
      this.transfer.destinationFund = item.id
    },
    setTransfer () {
      if (this.checkInputs()) {
        this.transfer.date = new Date()
        this.$emit('setTransfer', this.transfer, 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-fund-transfer {

    &__label {
      min-width: 57px;
    }

    &__button {
      margin: 28px auto 0;
      width: 117px;
    }

    &__select {
      font-weight: 300;
      font-size: 12px;
      line-height: 14px;
      height: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/Funds/TransferWindow/TransferWindow.vue